import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import { HOME } from '../constants/routes';
import pikkoCry from '../styles/img/reports/pikkoCry.svg';

const REDIRECT_DELAY = 5;

const NotFoundScreen = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const isLoggedIn = !!user?._id;

  const [countdown, setCountdown] = useState(REDIRECT_DELAY);
  const [mounted, setMounted] = useState(false);

  const goHome = useCallback(() => {
    navigate(HOME);
  }, [navigate]);

  useEffect(() => {
    requestAnimationFrame(() => setMounted(true));
  }, []);

  useEffect(() => {
    if (countdown <= 0) {
      goHome();
      return;
    }
    const timer = setTimeout(() => setCountdown((c) => c - 1), 1000);
    return () => clearTimeout(timer);
  }, [countdown, goHome]);

  return (
    <div
      className={clsx(
        'relative flex flex-col items-center justify-between min-h-screen overflow-hidden',
        isLoggedIn ? 'bg_background' : 'bg-gradient2',
      )}
    >
      {/* Content */}
      <div className="flex-1 flex flex-col items-center justify-center relative z-[1] px-8">
        <img
          src={pikkoCry}
          alt="Pikko"
          className="w-[110px] h-auto mb-7 drop-shadow-lg"
          style={{
            opacity: mounted ? 1 : 0,
            animation: mounted ? 'nf-bounce-in 0.7s cubic-bezier(0.34, 1.56, 0.64, 1) forwards' : 'none',
          }}
        />

        {/* 404 */}
        <div
          className={clsx(
            "font-['geomanistbold'] font-extrabold leading-none mb-3 text-7xl",
            isLoggedIn ? 'nf-404-gradient-green' : 'nf-404-gradient-white',
          )}
          style={{
            opacity: mounted ? 1 : 0,
            animation: mounted ? 'nf-fade-up 0.6s ease-out 0.15s both' : 'none',
          }}
        >
          404
        </div>

        <h1
          className={clsx(
            "font-['geomanistbold'] text-3xl mb-3 text-center",
            isLoggedIn ? 'text-[#1a1a1a]' : 'text-white',
          )}
          style={{
            opacity: mounted ? 1 : 0,
            animation: mounted ? 'nf-fade-up 0.6s ease-out 0.3s both' : 'none',
          }}
        >
          Page introuvable
        </h1>

        <p
          className={clsx(
            "font-['geomanistmedium'] text-lg text-center leading-relaxed",
            isLoggedIn ? 'text-[#666]' : 'text-white/85',
          )}
          style={{
            opacity: mounted ? 1 : 0,
            animation: mounted ? 'nf-fade-up 0.6s ease-out 0.45s both' : 'none',
          }}
        >
          Cette page n'existe pas ou a été déplacée.
        </p>

        <p
          className={clsx(
            "font-['geomanistmedium'] text-base text-center mt-6",
            isLoggedIn ? 'text-[#aaa]' : 'text-white/60',
          )}
          style={{
            opacity: mounted ? 1 : 0,
            animation: mounted ? 'nf-fade-up 0.5s ease-out 0.6s both' : 'none',
          }}
        >
          Redirection dans {countdown}s...
        </p>

        {/* Progress bar */}
        <div
          className={clsx(
            'w-[140px] h-[5px] rounded-full mt-3.5 overflow-hidden',
            isLoggedIn ? 'bg-black/[0.06]' : 'bg-white/25',
          )}
          style={{
            opacity: mounted ? 1 : 0,
            animation: mounted ? 'nf-fade-up 0.5s ease-out 0.65s both' : 'none',
          }}
        >
          <div
            className={clsx(
              'h-full rounded-full',
              isLoggedIn ? 'nf-progress-logged' : 'nf-progress-guest',
            )}
            style={{
              animation: mounted ? `nf-progress-fill ${REDIRECT_DELAY}s linear forwards` : 'none',
            }}
          />
        </div>
      </div>

      {/* Button */}
      <div
        className="w-full px-8 py-6 pb-10 relative z-[1]"
        style={{
          opacity: mounted ? 1 : 0,
          animation: mounted ? 'nf-btn-in 0.6s ease-out 0.7s both' : 'none',
        }}
      >
        <button
          onClick={goHome}
          className="primary-button cursor-pointer border-none active:translate-y-2 active:opacity-80 active:shadow-none"
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
};

export default NotFoundScreen;
